import "moment-timezone";
import React, { Component } from "react";
import 'react-block-ui/style.css';
import { Nav, NavItem } from 'react-bootstrap';
import { Route, Switch } from 'react-router';
import { Link } from "react-router-dom";
import LoadingIndicator from "../Components/LoadingIndicator/LoadingIndicator";
import DealsService from '../utils/DealsService';
import ReferenceService from '../utils/ReferenceService';
import DealsListView from './DealsListView';




class Deals extends Component {
  constructor(props) {
    super(props);

    const { view } = props.match.params
    this.state = { activeView: view, stats: {} }

  }

  componentDidMount() {
    ReferenceService.get('sms_group_messages').then(data => {
      this.setState({ smsGroupMessages: data })
    });
    ReferenceService.get('email_group_messages').then(data => {
      this.setState({ emailGroupMessages: data })
    });

    this.fetchStats()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      this.setState({ view: this.props.view })
    }
  }

  fetchStats() {
    DealsService.stats().then(data => {
      this.setState({ stats: data });
    });
  }

  handleSelect = (eventKey) => {
    this.setState({ activeView: eventKey }, () => {
    });
  }

  render() {
    const { stats } = this.state;
    const blockUI = !this.state.smsGroupMessages || !this.state.emailGroupMessages
    return (
      <LoadingIndicator loadingInProgress={blockUI}>
        <div>
          <h1 className="first-title" style={{ marginBottom: '20px' }}>
            Deals
            </h1>
          <div className='row'>
            <div className='col-md-12'>
              <Nav bsStyle="tabs" activeKey={this.state.activeView} onSelect={this.handleSelect.bind(this)}>
                <NavItem eventKey='open' componentClass={Link} to={`/m1/deals/list/open`} href={`/m1/deals/list/open`}>Open <span>({stats.open || 0})</span></NavItem>
                <NavItem eventKey='on_hold' componentClass={Link} to={`/m1/deals/list/on_hold`} href={`/m1/deals/list/on_hold`}>On Hold <span>({stats.on_hold || 0})</span></NavItem>
                <NavItem eventKey='verification' componentClass={Link} to={`/m1/deals/list/verification`} href={`/m1/deals/list/verification`}>Need Verification <span>({stats.verification || 0})</span></NavItem>
                <NavItem eventKey='upgrade' componentClass={Link} to={`/m1/deals/list/upgrade`} href={`/m1/deals/list/upgrade`}>Need Upgrade <span>({stats.upgrade || 0})</span></NavItem>
                <NavItem eventKey='followup' componentClass={Link} to={`/m1/deals/list/followup`} href={`/m1/deals/list/followup`}>Need QC Call <span>({stats.followup || 0})</span></NavItem>
                <NavItem eventKey='review' componentClass={Link} to={`/m1/deals/list/review`} href={`/m1/deals/list/review`}>Ready for Final Review <span>({stats.review || 0})</span></NavItem>
                <NavItem eventKey='completed' componentClass={Link} to={`/m1/deals/list/completed`} href={`/m1/deals/list/completed`}>Completed</NavItem>
              </Nav>
              <div className="tab-content">
                <Switch>
                  <Route path={'/m1/deals/list/:view'} render={(props) => <DealsListView view={this.state.activeView} smsGroupMessages={this.state.smsGroupMessages} emailGroupMessages={this.state.emailGroupMessages} {...props} />} />
                </Switch>
              </div>
            </div>
          </div>

        </div>
      </LoadingIndicator>

    );
  }
}
export default Deals;
